import { NavigationMenuLink } from '@radix-ui/react-navigation-menu';
import { NavLinkType } from '@upright/ui/common/generic/content/texts/bou-link/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { ExternalLinkItem, InternalLinkItem } from '../shared';

interface Props {
  to: string;
  children: ReactNode;
  linkType: NavLinkType;
  id?: string;
}

/*
Custom component for Radix Navigation Menu links. Recommended to ensure accessibility and consistent keyboard control.
See https://www.radix-ui.com/docs/primitives/components/navigation-menu#with-client-side-routing
*/

export const MenuLink = (props: Props) => {
  /*
  If we'd want to style the links based on current URL, pass an active prop to Radix' NavigationMenuLink.

  const location = useLocation();
  const isActive = location.pathname === props.to;
  */

  switch (props.linkType) {
    case NavLinkType.INTERNAL:
      return (
        <StyledMenuLink asChild>
          <InternalLinkItem to={props.to} id={props.id}>
            {props.children}
          </InternalLinkItem>
        </StyledMenuLink>
      );
    case NavLinkType.EXTERNAL:
      return (
        <StyledMenuLink asChild>
          <ExternalLinkItem href={props.to} target="_blank" id={props.id}>
            {props.children}
          </ExternalLinkItem>
        </StyledMenuLink>
      );
    default:
      throw Error('Unexpected link type');
  }
};

const StyledMenuLink = styled(NavigationMenuLink)`
  &:focus {
    color: ${BouColor.TOOL_HOVER_LIGHT_GRAY};
  }
`;
